import gsap from 'gsap';
import Choices from 'choices.js';
import $ from '../core/Dom';
import request from '../core/request';

export default el => {
    const baseUrl = $(el).data('url');
    const results = $('[data-recipies-results]');
    const breadcrumbs = $('[data-breadcrumb-items]');
    // const breadcrumb = $('.breadcrumb');
    const helpers = $(el).find('[data-helper]');

    let isPopping = false;
    let choices = null;

    const loadUrl = url => {
        gsap.to(results.find('.recipies__item, [data-no-hits]').nodes, { duration: 0.2, opacity: 0, ease: 'sine.easeIn' });
        request.get(url).then(res => {
            const response = $(res.text).find('[data-recipies-results]');
            results.html(response.html());
            isPopping = false;
        }, error => {
            console.error(error);
        });
    };

    const removeBreadcrumb = () => {
        breadcrumbs.find('[data-recipe-breadcrumb]').parent().remove();
    };

    const updateBreadcrumb = (url, values) => {
        let breadcrumb = breadcrumbs.find('[data-recipe-breadcrumb]');
        if (!breadcrumb.length) {
            breadcrumbs.append('<li class="breadcrumb__item"><a href="#" class="breadcrumb__item-link" data-recipe-breadcrumb></a></li>');
            breadcrumb = breadcrumbs.find('[data-recipe-breadcrumb]');
        }
        if (url && values) {
            breadcrumb.attr('href', url);
            breadcrumb.html(values.map(item => item.label).join(', '));
        }
    };

    const onPopstate = e => {
        console.log(e);
        isPopping = true;
        choices.removeActiveItems();
        if (e.state && e.state.values) {
            choices.setValueByChoice(e.state.values.map(item => item.value));
            updateBreadcrumb(document.location.href, e.state.values);
        } else {
            removeBreadcrumb();
        }
        loadUrl(document.location.href);
    };

    const onUpdate = () => {
        if (!isPopping) {
            const values = choices.getValue();
            const partials = values.map(item => (values.length > 1 ? item.customProperties.slug : item.customProperties.url));

            let newUrl = values.length ? `${baseUrl}/${partials.join('-')}` : baseUrl;
            newUrl = values.length === 1 ? partials[0] : newUrl;

            window.history.pushState({ values }, '', newUrl);

            choices.hideDropdown();
            if (values.length) {
                updateBreadcrumb(newUrl, values);
            } else {
                removeBreadcrumb();
            }
            loadUrl(newUrl);
        }
    };

    const init = () => {
        choices = new Choices($(el).find('#ingredients').get(0), {
            loadingText: 'Laster...',
            noResultsText: 'Ingen treff',
            itemSelectText: 'Klikk for å velge',
            removeItemButton: true,
            searchResultLimit: 10,
            searchFields: ['customProperties.keys'],
            choices: $(el).data('ingredients'),
            fuseOptions: {
                shouldSort: true,
                findAllMatches: true,
                threshold: 0.3,
                location: 0,
                distance: 300
            }
        });

        choices.passedElement.addEventListener('addItem', onUpdate);
        choices.passedElement.addEventListener('removeItem', onUpdate);
        helpers.on('click', e =>{
            e.preventDefault();
            choices.setValueByChoice($(e.target).data('id'));
        });

        window.addEventListener('popstate', onPopstate);
    };

    const destroy = () => {
        if (choices) {
            choices.destroy();
        }
        window.removeEventListener('popstate', onPopstate);
    };

    return {
        init,
        destroy
    };
};
